export class LSData {
  rememberId = "";
}
